import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, LogIn, LogOut, Menu, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          DanHunt
        </Link>

        <div className={`navbar-links ${mobileMenuOpen ? 'open' : ''}`}>
          <Link to="/puzzles" className="navbar-link" onClick={() => setMobileMenuOpen(false)}>
            Puzzles
          </Link>
          <Link to="/games" className="navbar-link" onClick={() => setMobileMenuOpen(false)}>
            Games
          </Link>
          
          {user ? (
            <>
              <Link to="/profile" className="navbar-link" onClick={() => setMobileMenuOpen(false)}>
                <User size={18} />
                <span>{user.displayName}</span>
              </Link>
              <button onClick={handleLogout} className="navbar-link navbar-button">
                <LogOut size={18} />
                <span>Logout</span>
              </button>
            </>
          ) : (
            <Link to="/login" className="navbar-link" onClick={() => setMobileMenuOpen(false)}>
              <LogIn size={18} />
              <span>Login</span>
            </Link>
          )}
        </div>

        <button 
          className="navbar-mobile-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
